import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const fontSizeSmall = 12;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DragAndDropQueuesContainerBorderCompiled = styled.div<{
	isDragging?: boolean;
	isDraggingOver?: boolean;
	isDropDisabled?: boolean;
}>(
	{
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		borderRadius: `${gridSize}px`,
		boxSizing: 'border-box',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isDropDisabled }) =>
		isDropDisabled &&
		`border: 2px dashed transparent;
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
    background-color: ${token('elevation.surface.sunken')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isDropDisabled, isDragging }) =>
		!isDropDisabled &&
		!isDragging &&
		`border: 2px dashed transparent;
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
    background-color: ${token('elevation.surface.sunken')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isDropDisabled, isDragging, isDraggingOver }) =>
		!isDropDisabled &&
		isDragging &&
		isDraggingOver &&
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		`border: 2px dashed ${token('color.border.selected')};
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
    background-color: ${token('color.background.selected.hovered')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isDropDisabled, isDragging, isDraggingOver }) =>
		!isDropDisabled &&
		isDragging &&
		!isDraggingOver &&
		`border: 2px dashed ${token('color.border.selected')};
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        background-color: ${token('color.background.selected')}`,
);
